<template>
  <div>
    <TopNav />

    <div class="settings mtb15">
      <div class="container-fluid">
        <div class="row">
          <Menu />

          <div class="col-md-12 col-lg-9">
            <HeadBalance
              :currency="currency"
              :activeCurrencyObj="ccurrencyObj"
            />

            <ul class="nav nav-pills mb-3">
              <li class="nav-item">
                <a class="nav-link deposit-head active" href="#">
                  Deposit
                </a>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link withdraw-head text-white"
                  :to="`/settings/wallets/${currency}/withdraw`"
                >
                  Withdraw
                </router-link>
              </li>
            </ul>

            <NetworkSelector
              v-if="hasMultipleNetworks"
              v-model="selectedNetwork"
              :networks="walletGroups"
              :currency="currency"
            />

            <template v-if="canShowDepositContent">
              <!-- bagian address -->
              <EvmAddress
                v-if="activeAddressView == 'EvmAddress'"
                :currency="currency"
              />

              <CipherbcAddress
                v-if="activeAddressView == 'CipherbcAddress'"
                :key="activeNetwork"
                :currency="currency"
                :network="activeNetwork"
              />

              <!-- bagian currency info -->
              <EvmTokenInfo
                v-if="
                  ccurrencyObj.ccurrency_config.deposit_info_view ==
                  'EvmTokenInfo'
                "
                :activeCurrencyObj="ccurrencyObj"
              />

              <EvmEthInfo
                v-if="
                  ccurrencyObj.ccurrency_config.deposit_info_view ==
                  'EvmEthInfo'
                "
                :activeCurrencyObj="ccurrencyObj"
              />

              <!-- bagian manual deposit -->
              <EvmCoinBNBDepositManual
                v-if="
                  ccurrencyObj.ccurrency_config.deposit_manual_view ==
                  'EvmCoinBNBDepositManual'
                "
                :activeCurrencyObj="ccurrencyObj"
                :currency="currency"
              />

              <EvmCoinETHDepositManual
                v-if="
                  ccurrencyObj.ccurrency_config.deposit_manual_view ==
                  'EvmCoinETHDepositManual'
                "
                :activeCurrencyObj="ccurrencyObj"
                :currency="currency"
              />

              <EvmTokenDepositManual
                v-if="
                  ccurrencyObj.ccurrency_config.deposit_manual_view ==
                  'EvmTokenDepositManual'
                "
                :activeCurrencyObj="ccurrencyObj"
                :currency="currency"
              />
            </template>

            <!-- list deposit -->
            <DepositList :currency="currency" />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";
import {
  normalizeWalletGroups,
  resolveAddressView,
} from "@/applibs/walletGroupConfig.js";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";
import Menu from "@/components/Settings/Menu.vue";
import HeadBalance from "@/components/Settings/Wallets/HeadBalance.vue";
import NetworkSelector from "@/components/Settings/Wallets/NetworkSelector.vue";
import EvmAddress from "@/components/Settings/Wallets/Deposit/Address/EvmAddress.vue";
import CipherbcAddress from "@/components/Settings/Wallets/Deposit/Address/CipherbcAddress.vue";
import EvmTokenInfo from "@/components/Settings/Wallets/Deposit/Info/EvmTokenInfo.vue";
import EvmEthInfo from "@/components/Settings/Wallets/Deposit/Info/EvmEthInfo.vue";
import EvmCoinBNBDepositManual from "@/components/Settings/Wallets/Deposit/Manual/EvmCoinBNBDepositManual.vue";
import EvmCoinETHDepositManual from "@/components/Settings/Wallets/Deposit/Manual/EvmCoinETHDepositManual.vue";
import EvmTokenDepositManual from "@/components/Settings/Wallets/Deposit/Manual/EvmTokenDepositManual.vue";
import DepositList from "@/components/Settings/Wallets/Deposit/List.vue";

export default {
  components: {
    TopNav,
    Footer,
    Menu,
    HeadBalance,
    NetworkSelector,
    DepositList,
    EvmAddress,
    CipherbcAddress,
    EvmTokenInfo,
    EvmEthInfo,
    EvmCoinBNBDepositManual,
    EvmCoinETHDepositManual,
    EvmTokenDepositManual,
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      currency: this.$route.params.currency,
      selectedNetwork: "",
      ccurrencyObj: {
        ccurrency_config: {
          address_view: "",
          deposit_info_view: "",
          deposit_manual_view: "",
        },
      },

      user: {},
    };
  },

  computed: {
    walletGroups() {
      return normalizeWalletGroups(this.ccurrencyObj.ccurrency_wallet_group);
    },
    hasMultipleNetworks() {
      return this.walletGroups.length > 1;
    },
    activeAddressView() {
      if (this.hasMultipleNetworks) {
        return resolveAddressView(this.ccurrencyObj, this.selectedNetwork);
      }
      return resolveAddressView(this.ccurrencyObj, this.walletGroups[0]);
    },
    canShowDepositContent() {
      if (this.hasMultipleNetworks) {
        return this.selectedNetwork !== "";
      }
      return true;
    },
    activeNetwork() {
      if (this.hasMultipleNetworks) {
        return this.selectedNetwork;
      }
      return this.walletGroups[0] || "";
    },
  },

  async beforeMount() {
    var self = this;
    // cek expire token
    if (self.token) {
      var res = await thestore.postCheckToken(self.token);
      if (res.success == false) {
        Cookies.remove("jwt");
        Cookies.remove("usid");
        self.$router.go();
      }
    } else {
      self.$router.push("/");
    }
  },

  async mounted() {
    var self = this;
    await self.getCcurrencyData();
    await self.getUserData();
  },

  methods: {
    async getUserData() {
      var self = this;

      // ambil data dia ketika login
      if (self.token != null && self.token != "") {
        var res = await thestore.getMyProfileData(self.token);
        self.user = res;
      } else {
        self.$router.push("/");
      }
    },

    async getCcurrencyData() {
      var self = this;
      var filter_rules = [
        { field: "ccurrency_symbol", op: "equal", value: self.currency },
      ];
      var res = await thestore.getCurrencies(1, 1, "id", "desc", filter_rules);
      self.ccurrencyObj = res.datas[0];
    },
  },
};
</script>

<style scoped>
.settings .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #fedba1 !important;
}
</style>
